import React from "react";
import { NavLink } from "react-router-dom";
import styles from './Panel.module.scss'

export type IPanelItem = {
    item:{icon?: any,
    name: string, url: string, imageUrl: string},
    open: boolean,
    disabled?: boolean,
}

const PanelItem:React.FC<IPanelItem> = ({item, open, disabled}) => {
    const inner = (
        <div className={(open ? styles.panelItemMain  + ' ' + 'panelItemMain' : styles.panelItemMain) + (disabled ? ' ' + styles.disabled : '')}>
            <div className={!open ? styles.icon + ' ' + 'panelItemMain' : styles.icon}>
                <img width={'25px'} src={item.imageUrl}/>
            </div>
            {open ? <div className={styles.name}>
                {item.name}
            </div> : null }
        </div>
    )

    // Заглушённый пункт: без навигации (не NavLink), некликабельный, приглушённый.
    // Случайный клик на показе ничего не ломает.
    if (disabled) {
        return (
            <div
                className={styles.disabledLink}
                title={'Недоступно в демо'}
                aria-disabled={true}
                onClick={(e) => e.preventDefault()}
            >
                {inner}
            </div>
        )
    }

    return (
        <NavLink to={item.url}>{inner}</NavLink>
    )
}

export default PanelItem
